import {h, Component} from 'preact';
import style from './style.scss';

export default class HeaderArrow extends Component{
    render() {
        const direction = this.props.direction;
        const callback = this.props.callback;
        return (
            <div className={style.Arrow} onClick={callback}>
                <i className={style[direction]}/>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/Header/Arrow/index.js